// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.img {
  width: 100%;
  max-width: 280px;
  min-width: 150px;
  margin-bottom: 40px;
}

.resend-a {
  color: #0063cf !important;
  cursor: pointer;
  text-decoration: none;
}

.check img {
  width: 125px;
  height: 125px;
}

.text-dark-grey {
  color: #757C8A !important;
}

.zikata-token-sent {
  height: 100vh;
  padding-top: 80px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRva2VuLXNlbnQuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxXQUFBO0VBQ0EsZ0JBQUE7RUFDQSxnQkFBQTtFQUNBLG1CQUFBO0FBQ0Y7O0FBRUE7RUFDRSx5QkFBQTtFQUNBLGVBQUE7RUFDQSxxQkFBQTtBQUNGOztBQUdFO0VBQ0UsWUFBQTtFQUNBLGFBQUE7QUFBSjs7QUFJQTtFQUNJLHlCQUFBO0FBREo7O0FBSUE7RUFDRSxhQUFBO0VBQ0EsaUJBQUE7QUFERiIsImZpbGUiOiJ0b2tlbi1zZW50LmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmltZyB7XG4gIHdpZHRoOiAxMDAlO1xuICBtYXgtd2lkdGg6IDI4MHB4O1xuICBtaW4td2lkdGg6IDE1MHB4O1xuICBtYXJnaW4tYm90dG9tOiA0MHB4O1xufVxuXG4ucmVzZW5kLWEge1xuICBjb2xvcjogIzAwNjNjZiAhaW1wb3J0YW50O1xuICBjdXJzb3I6IHBvaW50ZXI7XG4gIHRleHQtZGVjb3JhdGlvbjogbm9uZTtcbn1cblxuLmNoZWNrIHtcbiAgaW1nIHtcbiAgICB3aWR0aDogMTI1cHg7XG4gICAgaGVpZ2h0OiAxMjVweDtcbiAgfVxufVxuXG4udGV4dC1kYXJrLWdyZXkge1xuICAgIGNvbG9yOiAjNzU3QzhBICFpbXBvcnRhbnQ7XG59XG5cbi56aWthdGEtdG9rZW4tc2VudCB7XG4gIGhlaWdodDogMTAwdmg7XG4gIHBhZGRpbmctdG9wOiA4MHB4O1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./libs/auth/src/lib/components/token-sent/token-sent.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,yBAAA;EACA,eAAA;EACA,qBAAA;AACF;;AAGE;EACE,YAAA;EACA,aAAA;AAAJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACE,aAAA;EACA,iBAAA;AADF;AACA,g9BAAg9B","sourcesContent":[".img {\n  width: 100%;\n  max-width: 280px;\n  min-width: 150px;\n  margin-bottom: 40px;\n}\n\n.resend-a {\n  color: #0063cf !important;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.check {\n  img {\n    width: 125px;\n    height: 125px;\n  }\n}\n\n.text-dark-grey {\n    color: #757C8A !important;\n}\n\n.zikata-token-sent {\n  height: 100vh;\n  padding-top: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
